// extracted by mini-css-extract-plugin
export var landing = "testimonials-module--landing--1OQX-";
export var grid = "testimonials-module--grid--11IZg";
export var item = "testimonials-module--item--MdamS";
export var itemInfo = "testimonials-module--item-info--3Fi7k";
export var knowmore = "testimonials-module--knowmore--1BVvi";
export var filterContainer = "testimonials-module--filter-container--2xOtJ";
export var filterWrapper = "testimonials-module--filter-wrapper--210AV";